<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="button-wrapper bothbuttdiv3">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" type="button" (click)="submitData()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%">
                  <div class="col-lg-3">
                    <label>Jounrney Type</label>

                    <select name="COUNTRY_CODE" class="form-control" [(ngModel)]="screen_details.jounrney"
                      [disabled]=true>
                      <option disabled value="0">Select Journey Name</option>
                      <option value="{{ combo.type }}" *ngFor="let combo of Journey_details">{{ combo.name }}</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label>Start Range</label>
                    <input [disabled]=true name="CREDENTIAL_NAME" [(ngModel)]="screen_details.srange"
                      class="form-control m-input" type="text" placeholder="Enter Start Range" />
                  </div>

                  <div class="col-lg-3">
                    <label>End Range</label>
                    <input [disabled]=true name="CREDENTIAL_NAME" [(ngModel)]="screen_details.erange"
                      class="form-control m-input" type="text" placeholder="Enter End Range" />
                  </div>
                  <div style="height:79px ;"></div>
                  <div class="col-lg-12" style="border-top: 1px solid #d8d5d5;margin-left: 16px;padding: 10px;">
                  </div>

                  <table class="table table-bordered" aria-describedby="convFeeTPM">
                    <thead>
                      <tr>
                        <th scope="col">Cabin Class</th>
                        <th scope="col">Start Time</th>
                        <th scope="col">End Time</th>
                        <th scope="col">Convenience Fee</th>
                        <th scope="col">Segment</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <select [disabled]=true name="COUNTRY_CODE" class="form-control"
                            [(ngModel)]="screen_details.Cabindetails">
                            <option disabled value="0">Select Cabin Name</option>
                            <option value="{{ combo.type }}" *ngFor="let combo of Cabindetails">{{ combo.name }}
                            </option>
                          </select>
                        </td>

                        <td>
                          <input [disabled]=true [(ngModel)]="screen_details.startT" name="CREDENTIAL_NAME"
                            class="form-control m-input" type="text" placeholder="Start Time" />
                        </td>
                        <td>
                          <input [disabled]=true [(ngModel)]="screen_details.endT" name="CREDENTIAL_NAME"
                            class="form-control m-input" type="text" placeholder="End Time" />
                        </td>
                        <td>
                          <input [(ngModel)]="screen_details.convienienceFee" name="CREDENTIAL_NAME"
                            class="form-control m-input" type="text" placeholder="Convenience Fee"
                            (keydown)="isNumberKey($event)" />
                        </td>

                        <td>


                          <select [disabled]=true name="COUNTRY_CODE" class="form-control"
                            [(ngModel)]="screen_details.segmentDetails">
                            <option disabled value="0">Select Segment Name</option>
                            <option value="{{ combo.name }}" *ngFor="let combo of Segment_details">{{ combo.name }}
                            </option>
                          </select>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div style="margin-left: 16px;">
                  <div class="col-lg-12" style="border-top: 1px solid #d8d5d5;margin-left: 16px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>{{ screentitle }}</h1>
    <div class="bothbuttdiv2">
      <button class="btn btn-primary commonbutt" type="button" (click)="Download()">
        <em class="fa fa-download" aria-hidden="true"></em>&nbsp;
        Download
      </button>

    </div>


    <div class="bothbuttdiv1">
      <button class="btn btn-primary commonbutt" type="button" (click)="openfileDialog()">
        <em class="fa fa-upload" aria-hidden="true"></em>&nbsp;
        Upload
      </button>
      <input type="file" id="fileLoader" name="files" title="Load File" (change)="fileChangeListener($event)"
        style="display: none;" />
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div>
                    <div class="col-lg-3">
                      <label>Jounrney Type</label>

                      <select name="COUNTRY_CODE" class="form-control" [(ngModel)]="search_details.jounrney">
                        <option disabled value="0">Select Journey Name</option>
                        <option value="{{ combo.type }}" *ngFor="let combo of Journey_details">{{ combo.name }}</option>
                      </select>
                    </div>

                    <div class="col-lg-3">
                      <label>Start Range</label>
                      <input name="CREDENTIAL_NAME" [(ngModel)]="search_details.srange" class="form-control m-input"
                        type="text" placeholder="Enter Start Range" (keydown)="isNumberKey($event)" />
                    </div>

                    <div class="col-lg-3">
                      <label>End Range</label>
                      <input name="CREDENTIAL_NAME" [(ngModel)]="search_details.erange" class="form-control m-input"
                        type="text" placeholder="Enter End Range" (keydown)="isNumberKey($event)" />
                    </div>
                    <div style="height:79px ;"></div>

                    <div class="col-lg-3">
                      <label>Cabin Class</label>

                      <select name="COUNTRY_CODE" class="form-control" [(ngModel)]="search_details.cabin">
                        <option disabled value="0">Select Cabin Name</option>
                        <option value="{{ combo.type }}" *ngFor="let combo of Cabindetails">{{ combo.name }}</option>
                      </select>
                    </div>

                    <div class="col-lg-3">
                      <label>Segment</label>

                      <select name="COUNTRY_CODE" class="form-control" [(ngModel)]="search_details.segment">
                        <option disabled value="0">Select Segment Name</option>
                        <option value="{{ combo.name }}" *ngFor="let combo of Segment_details">{{ combo.name }}</option>
                      </select>
                    </div>

                    <div class="btn clear-button button-margin">
                      <button style="margin-top: 20px;" class="btn btn-primary commonbutt" (click)="searchData()"
                        type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>
                  </div>
                  <br />

                  <div class="reportstatus" *ngIf="showSearch">
                    <table aria-describedby="showSearch" class="table table-striped" [mfData]="serachtabledata"
                      [mfRowsOnPage]="5">
                      <thead>
                        <tr>
                          <th scope="col" style="width: 13.33%">Actions</th>
                          <th scope="col" style="width: 13.33%">
                            <mfDefaultSorter by="email">Journey</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 13.33%">
                            <mfDefaultSorter by="email">Start Range
                            </mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 13.33%">
                            <mfDefaultSorter by="email">End Range</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 13.33%">
                            <mfDefaultSorter by="email">Cabin Class</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Convenience Fee</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 13.33%">
                            <mfDefaultSorter by="email">Segment</mfDefaultSorter>
                          </th>
                        </tr>
                      </thead>

                      <tr *ngFor="
                          let obj of search_Record
                            | paginate: { itemsPerPage: 10, currentPage: p }
                        ">
                        <td>
                          <button class="btn btn-default btn-circle" type="button"
                            (click)="showFormData(obj.TPM_ID, 1,obj)" data-toggle="modal" data-target="#myModal">
                            <em class="fa fa-eye"></em>
                          </button>

                          <button class="btn btn-default btn-circle" type="button"
                            (click)="showFormData(obj.TPM_ID, 2,obj)">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </td>

                        <td>{{ obj.TPM_JOURNEY_CODE }}</td>
                        <td>{{ obj.TPM_START_RANGE }}</td>
                        <td>{{ obj.TPM_END_RANGE }}</td>
                        <td>{{ obj.TPM_CABIN_CLASS_CODE }}</td>
                        <td>{{ obj.CONVIENIENCE_FEE }}</td>
                        <td>{{ obj.SEGMENT }}</td>
                      </tr>

                      <tbody></tbody>
                      <tfoot>
                        <tr>
                          <td colspan="7">
                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="myModal">
  <div class="modal-dialog" style="width: 1200px;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Convenience Fee TPM</h4>
        <button type="button" class="close" data-dismiss="modal">
          &times;
        </button>
      </div>

      <div class="modal-body">
        <div>
          <table aria-describedby="mmodal" style="margin:auto">

            <body style="background-color: #fff;">
              <ng-container *ngFor="let vw of EditRecord;let i=index">
                <ng-container *ngIf="i==0">
                  <tr>
                    <th scope="col">Journey Type:</th>
                    <td *ngIf="vw.TPM_JOURNEY_TYPE=='D'">&nbsp;Domestic</td>
                    <td *ngIf="vw.TPM_JOURNEY_TYPE!='D'">&nbsp;International</td>
                  </tr>
                  <tr>
                    <th scope="col">Start Range:</th>
                    <td>&nbsp;{{vw.TPM_START_RANGE}}</td>
                  </tr>
                  <tr>
                    <th scope="col">End Range:</th>
                    <td>&nbsp;{{vw.TPM_END_RANGE}}</td>
                  </tr>

                  <tr>
                    <th scope="col">Min Miles:</th>
                    <td>&nbsp;{{vw.JP_MIN_MILES}}</td>
                  </tr>

                  <tr>
                    <th scope="col">Max Miles:</th>
                    <td>{{vw.JP_MAX_MILES}}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </body>
          </table>
        </div>
        <div style="margin-top: 15px;border-top: 1px solid #c8c8c8;padding-top: 15px;">

          <table aria-describedby="tpmData" class="table table-bordered table-sm">
            <thead>
              <tr>
                <th scope="col">Cabin Class</th>
                <th scope="col">Start Time (24 hrs)</th>
                <th scope="col">End Time (24 hrs)</th>
                <th scope="col">Convenience Fee</th>
                <th scope="col">Segment</th>
                <th scope="col">RPM</th>
                <th scope="col">Multiplier</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vw of EditRecord1;let i=index">
                <td *ngIf="vw.TPM_CABIN_CLASS=='E'">Economy</td>
                <td *ngIf="vw.TPM_CABIN_CLASS!='E'">Business</td>
                <td>{{vw.TPM_START_TIME}}</td>
                <td>{{vw.TPM_END_TIME}}</td>
                <td>{{vw.CONVIENIENCE_FEE}}</td>
                <td>{{vw.SEGMENT}}</td>
                <td>{{vw.RPM}}</td>
                <td>{{vw.PLOUGHBACK_MULTIPLIER}}</td>
              </tr>

            </tbody>
          </table>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>